"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementNode = void 0;
var react_1 = __importDefault(require("react"));
var react_flow_renderer_1 = require("react-flow-renderer");
require("./styles/element-node.scss");
/**
 * ElementNode - Custom node component for strategy elements
 * Displays element name with configurable connection handles
 */
exports.ElementNode = function (_a) {
    var data = _a.data, id = _a.id;
    var handleMouseEnter = function () {
        if (data.onNodeHover) {
            data.onNodeHover(id);
        }
    };
    var handleMouseLeave = function () {
        if (data.onNodeHover) {
            data.onNodeHover(null);
        }
    };
    return (react_1.default.createElement("div", { className: "strategy-element-node", onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, style: {
            borderColor: data.isHovered || data.isConnected ? "#FF5800" : data.color,
        } },
        data.showLeftHandle && (react_1.default.createElement(react_flow_renderer_1.Handle, { type: "target", position: react_flow_renderer_1.Position.Left, id: "left", className: "element-handle", style: { backgroundColor: data.color, pointerEvents: "none" } })),
        react_1.default.createElement("div", { className: "element-content" },
            react_1.default.createElement("div", { className: "element-label" }, data.label)),
        data.showRightHandle && (react_1.default.createElement(react_flow_renderer_1.Handle, { type: "source", position: react_flow_renderer_1.Position.Right, id: "right", className: "element-handle", style: { backgroundColor: data.color, pointerEvents: "none" } }))));
};
